import { css, cx } from '@linaria/core';

import { SmartLink } from '../SmartLink';
import { isButtonProps, isLabelProps, isLinkProps } from './guards';
import type { SmartElementProps } from './types';

const disabled = css`
	pointer-events: none;
`;

export const SmartElement = (props: SmartElementProps) => {
	if (isLinkProps(props)) {
		return (
			<SmartLink
				{...props}
				className={cx(props.className, props.disabled && disabled)}
			/>
		);
	}

	if (isLabelProps(props)) {
		return <label {...props} />;
	}

	if (isButtonProps(props)) {
		return <button {...props} />;
	}

	return <div {...props} />;
};
